module.exports = __webpack_public_path__ + "static/media/Avenir-Light.21784c28.woff2";